"use client";

import React from "react";
import { Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-white/10 animate-pulse rounded-sm" />
          </li>)}
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="font-sans text-sm text-slate-300 transition-colors hover:text-primary-foreground">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function CorporateFooter() {
  return <section data-section-id="226368" id="pied-de-page-f2s" className="bg-primary pt-16 pb-8 text-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/">
              <img src="https://eternal-donkey.10web.cloud/wp-content/uploads/2026/05/logo_sahel_white_on_navy.png" alt="F2S - Sahel Forwardin Services" className="h-28 w-auto object-contain" loading="lazy" />
            </Link>
            <address className="font-sans text-sm not-italic leading-relaxed text-slate-300">Dieuppeul-Derklé Rue P x 4,<br />&nbsp;Dakar, Sénégal</address>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h4 className="font-default text-lg font-semibold tracking-tight text-primary-foreground">
              Services & Réseau
            </h4>
            <MenuProvider menu_id="18">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h4 className="font-default text-lg font-semibold tracking-tight text-primary-foreground">
              Contactez-nous
            </h4>
            <ul className="flex flex-col gap-3 font-sans text-sm text-slate-300">
              <li>
                <Link to="mailto:contact@f2s-logistics.com" className="transition-colors hover:text-primary-foreground">bc.f2s@sahelforwarding.com</Link>
              </li>
              <li>
                <Link to="tel:+221338000000" className="transition-colors hover:text-primary-foreground">+221 77 638 31 68</Link>
              </li>
              <li className="pt-2 opacity-80">
                Lundi au Vendredi, 08h00 - 18h00 GMT
              </li>
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h4 className="font-default text-lg font-semibold tracking-tight text-primary-foreground">
              Suivez-nous
            </h4>
            <div>
              <Link to="#" className="inline-flex items-center gap-2 font-sans text-sm text-slate-300 transition-colors hover:text-primary-foreground" newTab>
                <Linkedin className="size-5" />
                <span>LinkedIn</span>
              </Link>
            </div>
          </div>

        </div>

        <Separator className="my-10 bg-white/10" />

        {}
        <div className="text-center">
          <p className="mx-auto max-w-4xl font-sans text-xs leading-relaxed text-slate-400">
            Sahel Forwardin Services (F2S) est un commissionnaire de transport agréé. Nous assurons vos opérations de transit, fret maritime et aérien avec expertise et fiabilité à travers l'Afrique de l'Ouest et le monde.
          </p>
        </div>
      </div>
    </section>;
}